import React from 'react';
import {Stack, Typography} from '@mui/material';
import {useLastUserLocations} from '../contexts/LastUserLocationContext';
import {useTranslation} from "react-i18next";

const PreciseItems = () => {
    const {t} = useTranslation();

    const {lastUserLocationsInView} = useLastUserLocations();

    const preciseLocationsCount = lastUserLocationsInView.filter(
        (location) => location.location.isPrecise
    ).length;
    const impreciseLocationsCount = lastUserLocationsInView.filter(
        (location) => !location.location.isPrecise
    ).length;

    return (
        <Stack spacing={1}>
            <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant="body1">
                    {t("precise_locations_count_label")}
                </Typography>
                <Typography variant="body1" fontWeight="bold">
                    {preciseLocationsCount}
                </Typography>
            </Stack>

            <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant="body1">
                    {t("imprecise_locations_count_label")}
                </Typography>
                <Typography variant="body1" fontWeight="bold">
                    {impreciseLocationsCount}
                </Typography>
            </Stack>
        </Stack>
    );
};

export default PreciseItems;
